export const Logo = ({ size = 34, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 64 64"
    fill="none"
    className={className}
    aria-hidden="true"
  >
    <rect width="64" height="64" rx="14" fill="#0D111A" />
    <rect width="64" height="64" rx="14" stroke="rgba(255,194,75,0.4)" />
    <path
      d="M32 14 L18 46 M32 14 L46 46 M18 46 L46 46 M32 14 L32 34 M18 46 L32 34 M46 46 L32 34"
      stroke="#FFC24B"
      strokeWidth="2.2"
      strokeLinecap="round"
      opacity="0.85"
    />
    <circle cx="32" cy="14" r="5" fill="#FFC24B" />
    <circle cx="18" cy="46" r="5" fill="#0D111A" stroke="#FFC24B" strokeWidth="2.2" />
    <circle cx="46" cy="46" r="5" fill="#0D111A" stroke="#FFC24B" strokeWidth="2.2" />
    <circle cx="32" cy="34" r="4" fill="#10B981" />
  </svg>
);

export default Logo;
